<template>
    <div v-tooltip="'Order Filters'" class="acclaro-filter" data-cy="acclaro-filter">
        <a href="javascript:;" >
            <i class="acclaro-icon ai-filter af-icon clickable" v-on:click="toggleVisibility()"></i>
        </a>
        <section v-show="isVisible" class="af-dropdown" data-cy="filter-dropdown" ref="filterpop" v-bind:class="{'has-datepicker': datePicker.inline}">
            <ul class="filter-lists">
                <li
                    class="filter-list"
                    :key="list.domId"
                    v-for="list in filters"
                    v-bind:class="{active: expanded == list.name}"
                    v-bind:id="list.domId + '_ac_filter'">
                    <div class="filter-list-title" v-on:click="toggleList(list.name, list.domId)">
                        <span>{{list.label}} - <small class="filter-list-selected">{{getSelectedOption(list)}}</small></span>
                        <i v-bind:class="{'ai-expand-less': expanded == list.name, 'ai-expand-more': expanded != list.name}"
                           class="acclaro-icon"></i>
                         {{list.items}}
                    </div>
                    <ul v-bind:id="list.domId" class="filter-list-items">
                        <li
                            class="filter-list-item"
                            :key="itemKey"
                            v-for="(itemValue, itemKey) in list.options"
                            @click.stop="onItemClick(itemValue, itemKey, list.name, list.domId)">
                            <input
                                v-model="list.selectedOptions"
                                :value="itemKey"
                                type="checkbox"
                            >
                            <label v-html="itemValue"></label>
                        </li>
                        <li class="filter-list-item" v-if="list.isDate">
                            <button class="date-range-btn" v-on:click="toggleDateRangePicker(true)">
                                <!-- <check-icon v-if="datePicker.models[list.domId].start" :size="13" :fill-color="'#0069AA'"  /> -->
                                <input
                                    type="checkbox"
                                    v-bind:checked="isCustomChecked(list)"
                                    />
                                <span style="margin: 0 3px">
                {{datePicker.models[list.domId].start
                                    ? datePicker.models[list.domId].start + ' – ' + ( datePicker.models[list.domId].end || ' Select To Date' )
                                    : 'Custom Date Range'}}
              </span>
                            </button>
                        </li>
                    </ul>
                </li>
            </ul>
            <div class="af-datepicker-view">
                <div class="" v-for="list in filters" v-if="list.isDate  && expanded == list.name && datePicker.inline">
                    <div class="af-datepicker-header">
                        <h2>
                            <span>{{list.label}} {{ datePicker.models[list.domId].start ? '' : ' (Select From Date)' }}</span>
                            <span>
              {{datePicker.models[list.domId].start
                                ? '(' + datePicker.models[list.domId].start + ' - ' + ( datePicker.models[list.domId].end || ' Select To Date' ) + ')'
                                : ''}}
            </span>
                        </h2>
                        <close-icon class="af-datepicker-closebtn" :size="15" :fill="'#0069AA'"
                                    v-on:click="toggleDateRangePicker(false)"/>
                    </div>
                    <div class="adv-picker-container">
                        <VueCtkDateTimePicker
                            v-on:input="onNewDateRange($event, list)"
                            :no-shortcuts="true"
                            :range="true"
                            v-model="datePicker.models[list.domId]"
                            :color="datePicker.color"
                            :no-header="datePicker.noHeader"
                            :position="datePicker.position"
                            :format="datePicker.format"
                            :no-value-to-custom-elem="true"
                            :input-size="datePicker.inputSize"
                            :inline="datePicker.inline"/>
                        <VueCtkDateTimePicker/>
                    </div>
                </div>
            </div>
        </section>
        <div v-show="isVisible" class="afc-underlay" v-on:click="closeFilter($event)"></div>
    </div>

</template>

<script>
import { EventBus } from '../../event-bus.js';
import { FilterOutlineIcon, CheckIcon, CloseIcon } from '../icons.js';
import './style.scss';

export default {
    data() {
        return {
            filters: this.lists,
            expanded: "",
            isVisible: false,
            id: Math.floor(Math.random() * 100),
            datePicker: {
                models: {},
                color: '#0069AA',
                noHeader: true,
                position: null,
                format: 'YYYY-MM-DD',
                inputSize: 'lg',
                inline: false
            },
        }
    },

    /**
     * {filters: {
     *    account: {
     *      defaultKey: "all"
     *      domId: "account-filter"
     *      isDate: false
     *      label: "Account"
     *      name: "account"
     *      options: {all: "All", 1: "Acclaro Inc"}
     *      selectedOption: "all"
     *    }
     *    ...
     *  }
     */
    props: {
        lists: Object,
        openEmitName: {
            type: String,
            default: 'acclaro_filter:open',
        }
    },

    watch: {

        lists (value) {
            this.datePicker.models = this.getModels();

            this.filters = this.lists;
        }
    },

    computed: {

        datePickerActive () {
            return this.datePicker.inline;
        },

        activeFilterCount () {
            let count = 0;

            Object.keys(this.lists).forEach((key) => {
                let list = this.lists[key];

                if (list.selectedOptions !== [list.defaultKey]) count++;
            });

            return count;
        }
    },

    methods: {

        getModels () {
            let models = {};

            Object.keys(this.lists).forEach((x) => {
                let list = this.lists[x];
                let obj = {};

                const hasCustomKey = list.selectedOptions?.some(opt => opt?.includes('custom:'));

                if (hasCustomKey) {
                    const customSelection = list.selectedOptions.find(opt => opt?.includes('custom:'));
                    let range = customSelection.substring(7).split('|');

                    obj.start = range[0];
                    obj.end = range[1];
                }
                models[list.domId] = obj;
            });

            return models;
        },

        getSelectedOption(list) {
            const hasCustomKey = list.selectedOptions?.some(opt => opt?.includes('custom:'));

            if (hasCustomKey) {
                const customSelection = list.selectedOptions.find(opt => opt?.includes('custom:'));
                return customSelection.substring(7).replace('|', ' – ');
            }

            const selected = list.selectedOptions
                ?.map(opt => list.options[opt])
                .filter(Boolean)
                .join(', ');

            return selected || '';
        },

        closeFilter (event) {
            this.isVisible = false;
            this.expanded = "";
            this.datePicker.inline = false;
        },

        onItemClick (value, key, list_title, list_id) {
            this.$emit('item-click', {value, key, list_title, list_id})
        },

        toggleVisibility () {
            this.isVisible = !this.isVisible;

            if(!this.isVisible) {
                this.expanded = "";
            }
        },

        toggleList (key, domId) {
            if(this.expanded == key) {
                this.expanded = "";
            } else {
                this.expanded = key;
            }

            return;

            if (domId) {
                let $ele = $(`#${domId}_ac_filter`);
                let eleTopPos = $ele[0].offsetTop;
                let $expandChildren = $(`#${domId}`).children();
                let expandChildHeight = $($expandChildren[0]).outerHeight();
                let expandHeight = Math.min(125, $expandChildren.length * expandChildHeight);

                //@TODO - clean up logic here
                if (eleTopPos  > 90) {
                    this.$refs.filterpop.scrollTop = eleTopPos - expandHeight;
                }
            }
        },

        onNewDateRange (range, list) {
            let { name: list_title, domId: list_id } = list;

            list.selectedOptions = list.selectedOptions.filter(option => option === 'ovr');

            if (range.start && range.end) {
                let value = `${range.start}|${range.end}`;
                let key = `custom:${value}`;

                this.onItemClick(value, key, list_title, list_id);
            } else if (range.start) {
                // let value = list.defaultKey;
                // let key = value;
                //
                // this.onItemClick(value, key, list_title, list_id);
            }
        },

        toggleDateRangePicker (bol) {
            if (bol !== null && bol !== undefined) {
                this.datePicker.inline = bol;
            } else {
                this.datePicker.inline = !this.datePicker.inline;
            }

            if (this.datePicker.inline) {
                setTimeout(() => {
                    this.$refs.filterpop.scrollTop = 0;
                })
            }
        },

        isCustomChecked(filter) {
            // eslint-disable-next-line no-prototype-builtins
            return this.datePicker.models[filter.domId].hasOwnProperty('start')
        }
    },

    components: {
        FilterOutlineIcon,
        CheckIcon,
        CloseIcon
    },

    mounted() {
        EventBus.$on(this.openEmitName, () => {
            this.isVisible = true;
        })
    }
}
</script>
